module.exports = __webpack_public_path__ + "static/media/H0Y.07c6c3d6.jpg";